export interface SortItem<T> {
  by: T;
  direction?: SortDirection;
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}
